import Vue from 'vue';
import '@/plugins/vuetify';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store/store';
import * as db from '@/utils/database';
import VueAnalytics from 'vue-analytics';
import titleMixin from '@/utils/title';
import VueI18n from 'vue-i18n';
import messages from '@/plugins/i18n.json';
import { IIIFV3Label } from './types';

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: 'ja',
  messages,
});

Vue.config.productionTip = false;

Vue.prototype.processLabel = (label: string | IIIFV3Label) => {
  if (!label) return '';
  if (typeof label === 'string') {
    return label;
  } else {
    return Object.values(label)
      .map((value) => value.join(' '))
      .join('/');
  }
};

Vue.prototype.processThumbnail = (
  thumbnail:
    | string
    | { id: string, type: string }
    | { id: string, type: string }[],
) => {
  if (!thumbnail) return '';
  if (typeof thumbnail === 'string') {
    return thumbnail;
  } else if (Array.isArray(thumbnail)) {
    return thumbnail[0].id;
  } else if (thumbnail.id) {
    return thumbnail.id;
  } else {
    return '';
  }
};

(async () => {
  Vue.prototype.$db = db;
  new Vue({
    router,
    store,
    i18n,
    render: (h) => h(App),
  }).$mount('#app');
})();

Vue.mixin(titleMixin);

// moment
const VueMoment = require('vue-moment');
const moment = require('moment-timezone');
moment.locale('ja');

Vue.use(VueMoment, {
  moment,
});

Vue.use(VueAnalytics, {
  id: 'UA-90092457-1',
  router,
});
